export const VUEX_OPTIONS_FETCH = 'VUEX_OPTIONS_FETCH'
export const VUEX_OPTIONS_ASSIGN = 'VUEX_OPTIONS_ASSIGN'
export const VUEX_OPTIONS_PERMITTED_LOCATIONS = 'VUEX_OPTIONS_PERMITTED_LOCATIONS'
